import { useState } from "react";
import Modal from "../../UI/Modal";
import { Spinner } from "../../UI/Spinner";
import {
  getItems,
  getShowtimes,
  setKeyboardConfiguration,
  setLoyaltyData,
  setShowKeyboard,
} from "../../../redux/slices";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useKeyboard } from "../../../context/KeyboardContext";
import LoadMemberBenefits from "./LoadMemberBenefits";
import RegisterMember from "./RegisterMember";
import { LOYALTY_ACTIONS } from "../../../utils/constants";

const LoyaltyReload = ({ openStatus, closeFunc }) => {
  const [actionType, setActionType] = useState("");

  const renderActions = () => {
    switch (actionType) {
      case LOYALTY_ACTIONS.REGISTER:
        return <RegisterMember closeFunc={closeFunc} />;
      case LOYALTY_ACTIONS.LOAD_BENEFITS:
        return <LoadMemberBenefits closeFunc={closeFunc} />;
      default:
        return (
          <div className="h-full flex items-center justify-center px-6">
            <div className="w-full max-w-xl">
              <h3 className="text-center text-xl font-semibold text-primary mb-5">
                Loyalty Actions
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button
                  type="button"
                  aria-label="Register member"
                  className="group relative overflow-hidden rounded-xl p-5 text-white bg-gradient-to-br from-primary to-primary-dark shadow-lg transition-transform duration-200 hover:scale-[1.02] active:scale-[.99] focus:outline-none focus:ring-4 focus:ring-primary/30"
                  onClick={() => setActionType(LOYALTY_ACTIONS.REGISTER)}
                >
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-black/10 text-xl">
                      👤
                    </span>
                    <div className="text-left">
                      <div className="font-semibold">Register</div>
                      <div className="text-white/80 text-sm">
                        Create a new loyalty member
                      </div>
                    </div>
                  </div>
                </button>

                <button
                  type="button"
                  aria-label="Load member benefits"
                  className="group relative overflow-hidden rounded-xl p-5 text-slate-900 bg-gradient-to-br from-amber-50 via-stone-100 to-stone-200 border border-stone-200 shadow-lg transition-transform duration-200 hover:scale-[1.02] active:scale-[.99] focus:outline-none focus:ring-4 focus:ring-stone-300/60"
                  onClick={() => setActionType(LOYALTY_ACTIONS.LOAD_BENEFITS)}
                >
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-black/5 text-xl">
                      🎁
                    </span>
                    <div className="text-left">
                      <div className="font-semibold">Load Benefits</div>
                      <div className="text-slate-800/80 text-sm">
                        Lookup and apply member perks
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <Modal openStatus={openStatus} panelStyles="bg-white w-[40vw] h-[45vh]">
      {actionType ? (
        <button
          className="absolute top-2 left-2 text-red-500 text-2xl bg-red-100 border rounded-full flex items-center justify-center w-10 h-10 "
          onClick={() => setActionType("")}
        >
          <span className="text-2xl">←</span>
        </button>
      ) : (
        <button
          className="absolute top-2 left-2 text-red-500 text-2xl bg-red-100 border rounded-full flex items-center justify-center w-10 h-10 "
          onClick={closeFunc}
        >
          <span className="text-2xl">x</span>
        </button>
      )}
      {renderActions()}
    </Modal>
  );
};
export default LoyaltyReload;
